import { Link } from "react-router-dom";
import { NAV, SITE, DISCLAIMER_LONG } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      className="mt-24"
      style={{ background: "#2B302A", color: "#F7F6F2" }}
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="font-serif text-3xl sm:text-4xl leading-tight">
              Rewire <span style={{ color: "var(--rr-accent)" }}>&</span> Root
            </p>
            <p className="mt-4 text-sm leading-relaxed" style={{ color: "rgba(247,246,242,0.7)" }}>
              {SITE.tagline}.
            </p>
            <p className="mt-8 text-sm" style={{ color: "rgba(247,246,242,0.6)" }}>
              with {SITE.instructor.name}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.2em] uppercase mb-5" style={{ color: "rgba(247,246,242,0.5)" }}>
              Pages
            </p>
            <ul className="space-y-3 text-sm">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="rr-link"
                    data-testid={`footer-${item.testid}`}
                    style={{ color: "#F7F6F2" }}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs tracking-[0.2em] uppercase mb-5" style={{ color: "rgba(247,246,242,0.5)" }}>
              Contact
            </p>
            <a
              href={`mailto:${SITE.email}`}
              data-testid="footer-contact-email-link"
              className="rr-link text-sm"
              style={{ color: "#F7F6F2" }}
            >
              {SITE.email}
            </a>
          </div>
        </div>

        <div
          className="mt-16 pt-10 border-t"
          style={{ borderColor: "rgba(247,246,242,0.15)" }}
          data-testid="footer-disclaimer"
        >
          <p className="text-xs tracking-[0.2em] uppercase mb-4" style={{ color: "rgba(247,246,242,0.55)" }}>
            Important — This is not therapy
          </p>
          <p className="text-sm leading-relaxed max-w-3xl" style={{ color: "rgba(247,246,242,0.78)" }}>
            {DISCLAIMER_LONG}
          </p>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs" style={{ color: "rgba(247,246,242,0.45)" }}>
          <p>© {new Date().getFullYear()} Rewire and Root. All rights reserved.</p>
          <p>rewireandroot.com</p>
        </div>
      </div>
    </footer>
  );
}
